import { render } from "./FlowStatus.vue?vue&type=template&id=bcc4ea6a&scoped=true&ts=true"
import script from "./FlowStatus.vue?vue&type=script&lang=ts"
export * from "./FlowStatus.vue?vue&type=script&lang=ts"

import "./FlowStatus.vue?vue&type=style&index=0&id=bcc4ea6a&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc4ea6a"]])

export default __exports__